export default "__VITE_ASSET__BC7KR3sP__"